"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("./constants");
var _context = require("./context");
var _newColorsBrandingSt = require("./newColorsBranding.st.css");
var _madeforSt = require("./madefor.st.css");
var _excluded = ["dataHook", "className", "as", "children", "features", "typographyClass", "theme"];
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/WixStyleReactProvider/WixStyleReactProvider.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** Wix Style React Provider */
var WixStyleReactProvider = _ref => {
  var {
      dataHook,
      className,
      as = 'span',
      children,
      features = {},
      typographyClass,
      theme = {}
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_context.WixStyleReactContext.Provider, {
    value: _objectSpread({
      newBrandingClass: features[_constants.featuresMap.newColorsBranding] && _newColorsBrandingSt.classes.root
    }, features),
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(as, _objectSpread(_objectSpread({}, rest), {}, {
    'data-hook': dataHook,
    className: (0, _newColorsBrandingSt.st)(typographyClass, className, features[_constants.featuresMap.newColorsBranding] && _newColorsBrandingSt.classes.root, _madeforSt.classes.madefor, theme == null ? void 0 : theme.className)
  }), children));
};
WixStyleReactProvider.displayName = 'WixStyleReactProvider';
WixStyleReactProvider.propTypes = {
  /** Applied as data-hook HTML attribute that can be used to create driver in testing */
  dataHook: _propTypes.default.string,
  /** A css class to be applied to the component's root element */
  className: _propTypes.default.string,
  /** render as some other component or DOM tag */
  as: _propTypes.default.oneOf(['span', 'div']),
  /** A renderable node */
  children: _propTypes.default.node,
  /** A theme object applied on components */
  theme: _propTypes.default.object,
  /** Object which represent all features you would like to use. The available features are:
   * - `newColorsBranding`: new business dashboard colors
   * - `sidebarExperimentCollapsible`: sidebar component experiment to enable collapsible feature.
   * */
  features: _propTypes.default.shape({
    newColorsBranding: _propTypes.default.bool,
    sidebarExperimentCollapsible: _propTypes.default.bool
  })
};
var _default = exports.default = WixStyleReactProvider;
//# sourceMappingURL=WixStyleReactProvider.js.map